import React from 'react';
import { ExternalLink, Globe, FileText, Truck, Building2, Shield, Receipt } from 'lucide-react';

const GovernmentLinks = () => {
  const govLinks = [
    {
      name: 'Income Tax Portal',
      url: 'https://www.incometax.gov.in/iec/foportal/',
      description: 'File ITR, View Form 26AS, Tax Calculator',
      icon: <FileText size={24} />,
      color: '#1B5A7E'
    },
    {
      name: 'GST Portal',
      url: 'https://www.gst.gov.in/',
      description: 'GST Registration, Returns, Payments',
      icon: <Globe size={24} />,
      color: '#FF8C42'
    },
    {
      name: 'E-Way Bill',
      url: 'https://ewaybillgst.gov.in/',
      description: 'Generate & Manage E-Way Bills',
      icon: <Truck size={24} />,
      color: '#4CAF50'
    },
    {
      name: 'MCA Portal',
      url: 'https://www.mca.gov.in/content/mca/global/en/home.html',
      description: 'Company Registration, ROC Filings',
      icon: <Building2 size={24} />,
      color: '#9C27B0'
    },
    {
      name: 'CBIC Portal',
      url: 'https://www.cbic.gov.in/',
      description: 'Customs, Central Excise, GST Updates',
      icon: <Shield size={24} />,
      color: '#E91E63'
    },
    {
      name: 'TRACES',
      url: 'https://www.tdscpc.gov.in/en/home.html',
      description: 'TDS/TCS Statements, Form 16/16A Download',
      icon: <Receipt size={24} />,
      color: '#00897B'
    }
  ];

  return (
    <section className="government-links-section" data-testid="government-links-section">
      <div className="container">
        <h2 className="section-title-center">Useful Government Portals</h2>
        <p className="section-subtitle">
          Quick access to official tax and compliance websites
        </p>

        <div className="gov-links-grid">
          {govLinks.map((link, idx) => (
            <a
              key={idx}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="gov-link-card"
              data-testid={`gov-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
              style={{ '--card-accent': link.color }}
            >
              <div className="gov-link-icon" style={{ backgroundColor: link.color }}>
                {link.icon}
              </div>
              <div className="gov-link-content">
                <h3 className="gov-link-name">
                  {link.name}
                  <ExternalLink size={14} />
                </h3>
                <p className="gov-link-desc">{link.description}</p>
              </div>
            </a>
          ))}
        </div>

        <div className="gov-links-note">
          <p>
            <strong>Note:</strong> These are official government websites. For any assistance with 
            filings or registrations on these portals, feel free to contact us.
          </p>
        </div>
      </div>
    </section>
  );
};

export default GovernmentLinks;
